module.exports = __webpack_public_path__ + "img/gbwa-logo.3c769aa8.webp";